import type { EntityStatus } from '@ms/yammer-data-support';
import { getStatusForId } from '@ms/yammer-data-support';

import type { Entity, RequestStatusType, YammerState } from '../../state/types';

import { getId } from './getId';

type GetStatus = (state: YammerState, requestType: RequestStatusType, entityId: Entity['id']) => EntityStatus;
export const getStatus: GetStatus = (state, requestType, entityId) =>
  getStatusForId(state.requestStatuses, getId(requestType, entityId));

type IsFulfilled = (state: YammerState, requestType: RequestStatusType, entityId: Entity['id']) => boolean;
export const isFulfilled: IsFulfilled = (state, requestType, entityId) =>
  getStatus(state, requestType, entityId) === 'fulfilled';

type IsPending = (state: YammerState, requestType: RequestStatusType, entityId: Entity['id']) => boolean;
export const isPending: IsPending = (state, requestType, entityId) =>
  getStatus(state, requestType, entityId) === 'pending';

type IsRejected = (state: YammerState, requestType: RequestStatusType, entityId: Entity['id']) => boolean;
export const isRejected: IsRejected = (state, requestType, entityId) =>
  getStatus(state, requestType, entityId) === 'rejected';

type isNotRequested = (state: YammerState, requestType: RequestStatusType, entityId: Entity['id']) => boolean;
export const isNotRequested: isNotRequested = (state, requestType, entityId) =>
  getStatus(state, requestType, entityId) === 'notRequested';

type GetRejectedError = (
  state: YammerState,
  requestType: RequestStatusType,
  entityId: Entity['id']
) => unknown | undefined;
export const getRejectedError: GetRejectedError = (state, requestType, entityId) =>
  state.requestStatuses.rejected.byId[getId(requestType, entityId)];

type GetFulfilledTime = (
  state: YammerState,
  requestType: RequestStatusType,
  entityId: Entity['id']
) => number | undefined;
export const getFulfilledTime: GetFulfilledTime = (state, requestType, entityId) =>
  state.requestStatuses.fulfilled.byId[getId(requestType, entityId)]?.fulfilledTime;
